if (!window.globalContext) {
  window.globalContext = {};
}

export function getContextValue(name) {
  const value = window.globalContext[name];

  if (
    value === undefined ||
    value === null ||
    (value.startsWith && value.startsWith('$'))
  ) {
    return '';
  }

  return value;
}

export const getActionUrl = () => {
  const allowedQueryParams = ['display', 'language', 'market', 'ui_locales'];
  const actionUrl = getContextValue('action');
  const params = new URLSearchParams(window.location.search);
  const filteredParams = new URLSearchParams();
  for (const [key, value] of params.entries()) {
    if (allowedQueryParams.includes(key)) {
      filteredParams.append(key, value);
    }
  }
  const filteredSearch = filteredParams.toString();
  return filteredSearch ? `${actionUrl}?${filteredSearch}` : actionUrl;
};

export const isPolestar = getContextValue('brand')
  .toUpperCase()
  .includes('POLESTAR');

export const isDeployedInChina = getContextValue('REACT_APP_CLUSTER')
  ?.toUpperCase()
  .includes('CN');
